import { TreeManager } from '@basehub/utils/tree/index'
import { Block, CommonBlocksCompoundIndexes } from '../schema/block'
import { BlockRelationship } from '../schema/block-relationship'
import { idToSourceBlockId } from '../mutators/repo-space/block/mutators/copy-on-write'
import { isListBlock } from '../schema/type-casts'

export function addToDependenciesToRevalidate({
  dependenciesToRevalidate,
  current,
  prev,
  treeManager,
}: {
  dependenciesToRevalidate: Set<string>
  current: { block: Block; br: BlockRelationship }
  prev?: { block: Block; br: BlockRelationship }
  treeManager: TreeManager<Block, CommonBlocksCompoundIndexes>
}) {
  if (current.block.type === 'root') return

  dependenciesToRevalidate.add(current.br.sourceBlockId)

  if (current.br.structural) {
    dependenciesToRevalidate.add('__schema')
  }

  if (!prev || current.block.apiName !== prev.block.apiName) {
    if (current.br.structural) {
      dependenciesToRevalidate.add('__schema')
    }
    dependenciesToRevalidate.add(`__apiName:${current.br.parentId}`)
  }
  if (!prev || current.block.slug !== prev.block.slug) {
    if (current.br.structural) {
      dependenciesToRevalidate.add('__schema')
    }
    dependenciesToRevalidate.add(`__slug:${current.br.parentId}`)
  }
  if (
    (!current.block.slug || !current.block.apiName) &&
    (!prev || current.block.title !== prev.block.title)
  ) {
    if (current.br.structural) {
      dependenciesToRevalidate.add('__schema')
    }
    if (!current.block.apiName && current.br.structural) {
      dependenciesToRevalidate.add(`__apiName:${current.br.parentId}`)
    }
    if (
      !current.block.slug &&
      (current.br.structural ||
        (current.br.parentId &&
          ['list', 'reference'].includes(
            treeManager.getNode(current.br.parentId)?.value.type ?? ''
          )))
    ) {
      dependenciesToRevalidate.add(`__slug:${current.br.parentId}`)
    }
  }

  if (current.br.parentId) {
    const parent = treeManager.getNode(current.br.parentId)
    if (parent && isListBlock(parent.value)) {
      dependenciesToRevalidate.add(idToSourceBlockId(parent.value))
    }
  }

  // If parentId changed, also add dependencies for the previous parent hierarchy
  if (prev && prev.br.parentId !== current.br.parentId) {
    dependenciesToRevalidate.add(prev.br.parentId)
    dependenciesToRevalidate.add(current.br.parentId)
    dependenciesToRevalidate.add(`__apiName:${current.br.parentId}`)
    dependenciesToRevalidate.add(`__slug:${current.br.parentId}`)
    dependenciesToRevalidate.add(`__apiName:${prev.br.parentId}`)
    dependenciesToRevalidate.add(`__slug:${prev.br.parentId}`)
  }

  // If order changed, invalidate parent
  if (prev && prev.br.order !== current.br.order) {
    dependenciesToRevalidate.add(current.br.parentId)
    dependenciesToRevalidate.add(`__apiName:${current.br.parentId}`)
    dependenciesToRevalidate.add(`__slug:${current.br.parentId}`)
  }
}
